import { mainApi } from '../index';
import type { CustomerIdResponse, SetupIntentPayload, SetupIntentResponse, UpdatePaymentMethodPayload } from './types';

/**
 * Get or create Stripe customer ID
 */
export async function getCustomerId(): Promise<string> {
    const response = await mainApi.get<CustomerIdResponse>('v1/integrations/stripe/get-create-customer');
    return response.data.customer_id;
}

/**
 * Create a Stripe setup intent for setting up payment methods
 */
export async function createSetupIntent(customerId: string, token: string): Promise<string> {
    const payload: SetupIntentPayload = {
        token,
        customer_id: customerId,
    };

    const response = await mainApi.post<SetupIntentResponse>('/v1/stripe/create-setup-intent', payload);
    return response.data.secret;
}

/**
 * Update payment method for platform subscription
 */
export async function updatePaymentMethod(
    paymentMethodId: string,
    customerId: string
): Promise<{ acknowledged: boolean }> {
    const payload: UpdatePaymentMethodPayload = {
        paymentMethodId,
        customerId,
    };

    const response = await mainApi.post('v1/integrations/stripe/update-payment-method-platform', payload);
    return response.data;
}
